import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const FrontEndMiddleware = ({ children, allowedRoles }) => {
  const location = useLocation();
  const authUser = JSON.parse(localStorage.getItem("authClient"));
  const userRole = localStorage.getItem("userRole");

  if (!authUser) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default FrontEndMiddleware;
